<template>
  <div class="container">
    <form id="search-form">
      <div class="search">
        <v-text-field v-model="transcript" label="Notes" style="text-transform: uppercase;" outlined auto-grow rows="10" dark class="mb-2 transcript-textarea"></v-text-field>
        <v-btn class="ma-2" @click="startRecording" :disabled="isRecording" color="primary" large>Start Recording</v-btn>
        <v-btn class="ma-2" @click="stopRecording" :disabled="!isRecording" color="error" large>Stop Recording</v-btn>
      </div>
    </form>
    <p class="info">{{ infoText }}</p>
  </div>
</template>


<script>
import _ from 'lodash';
import submitAudio from '../assets/audio/input3.wav'; // Adjust path as necessary

export default {
  data() {
    return {
      transcript: '',
      isRecording: false,
      recognition: null,
      infoText: ''
    };
  },
  methods: {
    searchTermChange: _.debounce( function () {
      //  pass event up to parent App.vue
      this.$emit('termChange', this.searchTerm);
    }, 500),
    startRecording() {
      setTimeout(() => {
        this.transcript = 'You can start speaking now.';
        setTimeout(() => {
        new Audio(submitAudio).play();
      }, 100);
      }, 200);
      this.transcript = '';
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'en-US';

      this.recognition.onresult = (event) => {
        let finalTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const transcriptFragment = event.results[i][0].transcript.trim();
          finalTranscript += transcriptFragment;
        }
        this.transcript = finalTranscript;
      };

      this.recognition.onerror = (event) => {
        this.infoText = 'Error occurred in recognition: ' + event.error;
      };

      this.recognition.start();
      this.isRecording = true;
      // this.infoText = 'Processing your input...';
        setTimeout(() => {
          this.processTranscript();
        }, 5000);
        setTimeout(() => {
          this.stopRecording();
        }, 7000);
        
    },
    stopRecording() {
      if (this.recognition) {
        this.recognition.stop();
        this.recognition = null;
        this.isRecording = false;
      }
    },
    processTranscript() {
      this.$emit('termChange', this.transcript);
      this.infoText = 'Submitted: ' + this.transcript;
      this.transcript = ''; // Reset after processing
    }
  },
  mounted() {
    if (!('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
      console.error("This browser does not support desktop speech recognition.");
    }
  }
};
</script>

<style>
.transcript-textarea, .info-card, .saved-notes-card, .overlay-card {
  background-color: #001c3000;
  color: white;
  border-radius: 20px;
  font-size: 24px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-weight: normal;
      text-transform: lowercase;
  /* border: 1px solid #007bff; */
}
.transcript-textarea, .info-card, .saved-notes-card, .overlay-card:first-child {
  margin-top: 10px;
  text-transform: capitalize;

}
.highlighted-note {
  background-color: #009688;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}
.overlay-card {
  max-width: 700px;
  min-width: 500px;
}
</style>

<style scoped>

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.mdi-microphone {
  top: -7px;
  animation: pulse 1s infinite;
}
.image-container img {
  mask-size: 100% 200%;
  max-width: 100%;
  height: auto;
  /* animation: reveal-image 10s forwards; */
}
@keyframes scan-line {
  from {
    top: -100%;
  }
  to {
    top: 100%;
  }
}

@keyframes reveal-image {
  0% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #ff7e5f, #feb47b); /* Warm colors to start */
    mask-position: top;
    background-size: cover;
  }
  25% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to right, #00c6ff, #0072ff); /* Blue hues for scanning */
    background-size: cover;
  }
  50% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to right, #f953c6, #b91d73); /* Pink to deep violet transition */
    background-size: cover;
  }
  75% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #76b852, #8DC26F); /* Green, nature-like */
    background-size: cover;
  }
  100% {
    mask-image: linear-gradient(to bottom, transparent, black 50%, transparent);
    background: linear-gradient(to bottom, #4b6cb7, #182848); /* Dark blues for completion */
    mask-position: bottom;
    background-size: cover;
  }
}

.image-container {
  margin-top: 20px;
  text-align: center; /* Centering buttons and image */
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
    position: fixed;
  z-index: 9999; /* Ensure it's on top of everything */
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 100%;
  background: rgba(12, 22, 27, 0.962);
  /* animation: reveal-image 10s forwards; */
}

.saved-images-container {
    padding: 15px 15px 15px 15px;
    border: 1px solid #1d323b;
    border-radius: 5px;
    margin-top: -30px;
    margin-bottom: 10px;
    max-height: fit-content;
    background: #1d323bc7;
    overflow-y: auto;
    font-size: 19px;
    font-family: 'Nunito Sans', sans-serif;
    box-shadow: rgba(187, 187, 197, 0.05) 0px 20px 40px -12px inset, rgba(236, 235, 235, 0.10) 0px 12px 22px -6px inset;
}

.image-gallery {
  column-count: 3; /* Adjust based on your preference */
  column-gap: 20px;
  margin-left: -10px;
  margin-right: 10px;
  text-decoration: none !important;
}

.image-gallery > li {
  break-inside: avoid;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none !important;
  list-style: none;
}

/* Lightbox styles */
.lightbox {
  position: fixed;
  width: 60%;
  height: 60%;
  top: 44%;
  left: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background: linear-gradient(90deg, #0c161bd5, #0c161b8b);
  z-index: 1000; /* Make sure it's above other content */
  border-radius: 10px;
  text-align: center;
}

.image-gallery li img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  border-radius: 5px;
}

.image-gallery li .v-btn {
  opacity: 0.8;
  outline: 1px solid #fff; /* White outline */
  margin: 10px;
  background-color: rgba(0, 0, 139, 0.6); /* Transparent dark blue */
  color: white; /* Text color */
  border: none; /* Remove default border if any */
  border-radius: 4px; /* Optional: for rounded corners */
}

.image-gallery li .v-btn:hover {
  opacity: 1; /* Full opacity on hover */
}

.download-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: -10px;
  opacity: 0.8;
}
.save-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 0px;
  opacity: 0.8;
}
.close-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 10px;
  opacity: 0.8;
}
.overlay2 {
  background: rgba(0, 0, 0, 0.5);
  border: #000;
  border-radius: 10px;
  color: white;
  width: 100%;
  text-align: center;
  padding: 10px 10px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0c161b2f; /* Semi-transparent background */
}
.inputarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1.5) drop-shadow(0 0 10px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  width: 800px;
  height: 600px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 600px) {
  .inputarea {
    width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1.5) drop-shadow(0 0 10px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
  }
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
</style>
<style scoped>
  .container {
    padding: 30px 50px;
    width: auto;
  }
  .form-control-6 {
    border: 1px solid rgb(36, 212, 65);
    padding: 4px 4px;
    margin-block: 1px 3px;
    margin-top: 0.8rem;
    margin-left: 270px;
  }
  @media only screen and (max-width: 600px) {
  .form-control-6 {
    border: 1px solid #5e6570;
    padding: 20px 20px;
    margin-block: 3px 5px;
    border-radius: 10px;
    font-size: 12px;
    background: transparent;
    color: rgb(36, 212, 65);
  }
  }
  .container {
    padding: 30px 50px;
  }
  #search {
    width: 100%;
  }
  #search-form {
    width: 60%;
  }
  #search-form input {
    padding: 10px 10px;
    border: 1px solid rgb(36, 212, 65);
    width: 260px;
    margin-top: 30px;
    margin-left: 500px;
    border-radius: 5px;
    font-size: 12px;
    background: transparent;
    color: rgb(36, 212, 65);
    text-transform: capitalize;
  }
  .button {
    border: 1px solid rgb(36, 212, 65);
    border-radius: 5px;
    padding: 10px 10px;
    color: rgb(36, 212, 65);
    animation: glow 1s ease-in-out infinite alternate;
  }
  .info {
    top: 10px;
    margin-left: 11rem;
    width: 300px;
    text-align: center;
    font-size: 1.1rem;
    position: absolute;
    padding-left: 5px;
    padding-right: 5px;
    font-style: normal;
    color: rgb(51, 207, 77);
    border-radius: 5px;
  }
  @media (max-width: 1200px) {
    #search-form { width: 50%; }
  }
  @media (max-width: 768px) {
    .container { padding: 30px 35px; }
    #search-form { width: 100%; }
    .info { font-size: 0.5rem; }
  }
  </style>
